import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IQuizPassed } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class QuizPassedService extends BaseService<IQuizPassed> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'quizPassed');
  }

  reset(docId: number): Observable<number> {
    return this.http.put<number>(
      this.baseUrl + 'reset/' + docId,
      null,
      this.defaultOptions
    );
  }
}

export { IQuizPassed } from '../shared/api';
